import ShopifyObject from './ShopifyObject';
import CollectionImage from './CollectionImage';

export default class Collection extends ShopifyObject {
  /**
   * @param {ShopifyCollection} collection
   */
  constructor(collection) {
    super(collection.id);

    this._title = collection.title || '';
    this._handle = collection.handle || '';
    this._description = collection.description || '';
    this._publishedAt = collection.published_at || new Date(0);
    this._updatedAt = collection.updated_at || new Date(0);
    this._productsCount = collection.products_count || 0;
    this._image = collection.image
      ? new CollectionImage(collection.image)
      : null;
  }

  /**
   * @returns {string}
   */
  get title() {
    return this._title;
  }

  /**
   * @returns {string}
   */
  get handle() {
    return this._handle;
  }

  /**
   * @returns {string}
   */
  get description() {
    return this._description;
  }

  /**
   * @returns {Date}
   */
  get publishedAt() {
    return this._publishedAt;
  }

  /**
   * @returns {Date}
   */
  get updatedAt() {
    return this._updatedAt;
  }

  /**
   * @returns {CollectionImage}
   */
  get image() {
    return this._image;
  }

  /**
   * @returns {number}
   */
  get productsCount() {
    return this._productsCount;
  }

  /**
   *
   * @return {Object} - Shopify Collection Object.
   */
  JSON() {
    return {
      description: this.description,
      handle: this.handle,
      id: super.id,
      image: this.image ? this.image.JSON() : null,
      products_count: this.productsCount,
      published_at: this.publishedAt,
      title: this.title,
      updated_at: this.updatedAt,
    };
  }
}
